import { findChangedFormValues } from '../utils/findChangedFormValues';
import { shouldSkipFormChangeFieldKey } from './form-change-handler-common';
import type { FormInitialValues } from '../typings';

/**
 * Fields the user changed on top of a server-driven reset. Formik's `resetForm` sets
 * `values` to `initialValues`, so anything still different is an edit that landed inside
 * the reset cascade — the one thing the tracker's baseline latch would otherwise swallow.
 */
export const findEditsSurvivingReinitialize = (
  values: FormInitialValues,
  initialValues: FormInitialValues,
): FormInitialValues => {
  const current = { ...values };
  delete current['#'];

  const edits = findChangedFormValues(current, initialValues);

  // `initialValues` need not carry every synthetic validation key `values` holds, so
  // those would read as edits on every reinitialize — enqueuing a batch that produces no
  // requests and flashes the save chip for nothing.
  Object.keys(edits).forEach(fieldId => {
    if (shouldSkipFormChangeFieldKey(fieldId)) {
      delete edits[fieldId];
    }
  });

  return edits;
};
